import script from "./associationNews.vue?vue&type=script&setup=true&lang=js"
export * from "./associationNews.vue?vue&type=script&setup=true&lang=js"

import "./associationNews.vue?vue&type=style&index=0&id=0e41e025&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e41e025"]])

export default __exports__